import React, {memo} from "react";

import {excelDiffService} from "../services/excelDiffService";
import FileUploader from "shared/components/fileUploader";

const CustomFileUploader = ({position, currFileName, setCurrFileName, currFileLen, setCurrFileLen}: {position: number, currFileName: string, setCurrFileName: React.Dispatch<React.SetStateAction<string>>, currFileLen: number, setCurrFileLen: React.Dispatch<React.SetStateAction<number>>}) => {
    return (
        <FileUploader
            handleUploadFn={(fl: File) => excelDiffService.uploadCustomCsv(position, fl)}
            handleDownloadFn={null}
            currFileLen={currFileLen}
            setCurrFileLen={setCurrFileLen}
            currFileName={currFileName}
            setCurrFileName={setCurrFileName}
            reUploadMessage={`${currFileName} (${currFileLen} products)`}
        />
    );
};

export default memo(CustomFileUploader);
